import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=6ac9f623&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=6ac9f623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_webpack@4.47.0__css-loader@5.2.7_webp_aaeg4c7xsv2rwjah5qgerw23gy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac9f623",
  null
  
)

export default component.exports